import { render, staticRenderFns } from "./AskForNumber.vue?vue&type=template&id=6fefa394&"
import script from "./AskForNumber.vue?vue&type=script&lang=js&"
export * from "./AskForNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports